module.exports = __webpack_public_path__ + "img/5.27cde521.png";